export default __webpack_public_path__ + "static/media/flowers-1.5x.2aaabe63.png";